const CertificateData = [
  {
    id: "c1",
    drive:
      "https://drive.google.com/file/d/1L0hcVjjq0BNy8dyPPTbC5AT2w2IwZg1x/view?usp=sharing",
    Course_Name: "MERN-boot Camp",
    IssuedDate: "Issued by September 2020",
    University_logo:"./images/lco_logo.png"
     
  },{
    id: "c2",
    drive:
      "https://drive.google.com/file/d/1R3SpEKj8XB92aSu9Ml8hbkZJzAASXJyf/view?usp=sharing",
    IssuedDate: "Issued by July 2021",
    Course_Name: "React JS",
    University_logo: "./images/udemy_logo.png"
  },
  
  {
    id: "c3",
    drive:
      "https://drive.google.com/file/d/18EEnGT6T8gAdsonxVLSzds8oG7xKEOnE/view?usp=sharing",
    Course_Name: "Programming Foundations with JS",
    IssuedDate: "Issued by October 2020",
    University_logo:"./images/duke_logo.webp"
      
  },
  {
    id: "c4",
    drive:
      "https://drive.google.com/file/d/19xKNVjGZJuSIU-OuIRPfSOauRh_kHYZv/view?usp=sharing",
    IssuedDate: "Issued by Aug 2021",
    Course_Name: "Node JS",
    University_logo: "./images/udemy_logo.png"
  },
  {
    id: "c5",
    drive:
      "https://drive.google.com/file/d/1oHO8ujuDr8sC9BTQIR8i6aoxIszPU1FA/view?usp=sharing",
    IssuedDate: "Issued by July 2020",
    Course_Name: "Python for Everybody",
    University_logo:
      "./images/Michigen.webp"
  },
  {
    id: "c6",
    drive:
      "https://drive.google.com/file/d/1GSfBQfcq1yqCQeCUamWpEkly0ay4F6wA/view?usp=sharing",
    IssuedDate: "Issued by July 2020",
    Course_Name: "Introduction to CSS3",
    University_logo:  "./images/Michigen.webp",
  },
  {
    id: "c7",
    drive:
      "https://drive.google.com/file/d/1qr45uHWEaIpGkK49-9sgFgmxJvltMkCu/view?usp=sharing",
    IssuedDate: "Issued by June 2020",
    Course_Name: "Beginning SQL Server",
    University_logo: "./images/coursera.webp"
  },
  
  
];

export default CertificateData;
